export default {
      id: "alert-exclamation-icon-fill-usage",
      viewBox: "0 0 96 85",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#alert-exclamation-icon-fill",
      toString: function () {
        return this.url;
      }
    }